import { EmptyState, SkeletonList } from '@batiflow/ui';
import {
  Button,
  MessageBar,
  MessageBarActions,
  MessageBarBody,
  MessageBarTitle,
  __css,
  tokens,
} from '@fluentui/react-components';
import { PeopleSwap24Regular } from '@fluentui/react-icons';
import { useTranslation } from 'react-i18next';
import { SpaceRow, useMySpaces } from '@/features/spaces';

const useStyles = __css({"list":{"D305fb":"f1bjjmyr","dclx09":"ftrb29c","Bo78w4l":0,"Cgygva":0,"yil37a":"f8ntp42","Bnt446c":0,"B1hrpyx":0,"Fjva8n":"fgdu4nw","mc9l5x":"f22iagw","Beiy3e4":"f1vx9l62","Belr9w4":"f1wn3y0l"}});

/**
 * "Shared with me" (GED-FE-09): the spaces of other organisations the person joined (an
 * invitation they accepted); each opens the space, where its Documents tab shows what they reach.
 */
export function SharedWithMe() {
  const { t } = useTranslation('documents');
  const { t: tCommon } = useTranslation('common');
  const styles = useStyles();
  const spaces = useMySpaces();

  if (spaces.isError && !spaces.data)
    return (
      <MessageBar intent="error" layout="multiline">
        <MessageBarBody>
          <MessageBarTitle>{t('filesApp.shared.loadFailedTitle')}</MessageBarTitle>
          {t('filesApp.shared.loadFailedBody')}
        </MessageBarBody>
        <MessageBarActions>
          <Button
            onClick={() => {
              void spaces.refetch();
            }}
          >
            {tCommon('actions.retry')}
          </Button>
        </MessageBarActions>
      </MessageBar>
    );
  if (spaces.isPending) return <SkeletonList count={3} />;
  const external = spaces.data.items
    .filter((space) => space.external)
    .sort((a, b) => a.name.localeCompare(b.name));
  if (external.length === 0)
    return (
      <EmptyState
        illustration={<PeopleSwap24Regular />}
        title={t('filesApp.shared.emptyTitle')}
        description={t('filesApp.shared.emptyBody')}
      />
    );
  return (
    <ul className={styles.list} aria-label={t('filesApp.shared.listLabel')}>
      {external.map((space) => (
        <SpaceRow key={space.id} space={space} />
      ))}
    </ul>
  );
}


import "/opt/batiflow/app/apps/web/src/features/files/components/shared-with-me.griffel.css";